import { render, staticRenderFns } from "./BCTtable.vue?vue&type=template&id=d3734430&scoped=true"
import script from "./BCTtable.vue?vue&type=script&lang=js"
export * from "./BCTtable.vue?vue&type=script&lang=js"
import style0 from "./BCTtable.vue?vue&type=style&index=0&id=d3734430&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3734430",
  null
  
)

export default component.exports